"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardType = void 0;
var BoardType;
(function (BoardType) {
    BoardType["MARS"] = "mars";
    BoardType["MOON"] = "moon";
})(BoardType = exports.BoardType || (exports.BoardType = {}));
